import React, { useState } from "react";
import useCurrentDealStore from "stores/DealStore";
import { DealStatus } from "constants/Constants";
import shallow from "zustand/shallow";
import useCurrentLeaseStore from "../../../../stores/LeaseStore";
import {
	CurrencyInput,
	PercentInput,
} from "../../../forms/components/InputElement";
import {
	calculateResidualFactor,
	calculateResidualValue,
} from "../../helperFunctions/LeaseFunctions";
import { Col } from "reactstrap";

const ResidualInput = () => {
	const lease = useCurrentLeaseStore((state) => ({ ...state }), shallow);
	const { type } = useCurrentDealStore(
		(state) => ({
			type: state.deal.type,
		}),
		shallow
	);
	const [showResidual, setShowResidual] = useState("FACTOR");

	// For RTO (leaseType 6): use price, For Lease (leaseType 5): use msrp
	const baseValue = lease.leaseType === 6 ? lease.price : lease.msrp;

	const handleResidualFactor = (e) => {
		console.log(e, showResidual);
		if (showResidual === "VALUE") {
			return;
		}
		lease.editField("residualFactor", e);
		const ressValue = calculateResidualValue(
			baseValue,
			e
			//lease.mileageCharge
		);
		lease.editField("residualValue", ressValue);
	};
	const handleResidualValue = (e) => {
		console.log(e, showResidual);
		if (showResidual === "FACTOR") {
			return;
		}
		console.log("handleResidualValue");
		lease.editField("residualValue", e);
		lease.editField("residualFactor", calculateResidualFactor(e, baseValue));
	};
	return (
		<>
			<Col xl="3" className="mb-2">
				<PercentInput
					disableValidation
					readOnly={type !== DealStatus.PENDING}
					value={lease.residualFactor}
					onFocus={() => setShowResidual("FACTOR")}
					onChange={handleResidualFactor}
					name="residualFactor"
					label="residual %"
					decimalScale={2}
					wholeRow={true}
					colSize="col-xl-3"
				/>
			</Col>
			<Col xl="3" className="mb-2">
				<CurrencyInput
					disableValidation
					key="residualValue"
					value={lease?.residualValue ?? 0}
					onFocus={() => setShowResidual("VALUE")}
					onChange={handleResidualValue}
					name="residualValue"
					label="Residual Value"
					wholeRow={true}
					colSize="col-xl-3"
					readOnly={type !== DealStatus.PENDING}
				/>
			</Col>
		</>
	);
};

export default ResidualInput;
